class TabbedProducts extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('.custom-tabbed-products__tab'));
    this.panels = Array.from(this.querySelectorAll('.custom-tabbed-products__panel'));
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.select(Number(tab.dataset.tabIndex)));
      tab.addEventListener('keydown', (e) => this.onKeydown(e));
    });
  }

  select(index) {
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });
    this.panels.forEach((panel, i) => {
      const active = i === index;
      panel.classList.toggle('is-active', active);
      panel.toggleAttribute('hidden', !active);
    });
  }

  onKeydown(e) {
    const current = this.tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true');
    let next = null;
    if (e.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
    if (e.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
    if (next === null) return;
    e.preventDefault();
    this.select(next);
    this.tabs[next].focus();
  }
}

customElements.define('tabbed-products', TabbedProducts);

class CtpSwatchCard extends HTMLElement {
  connectedCallback() {
    this.swatches = Array.from(this.querySelectorAll('.ctp-swatch'));
    if (this.swatches.length < 2) return;

    this.image = this.querySelector('.ctp-card__image');
    this.titleLink = this.querySelector('.ctp-card__title');
    this.links = Array.from(this.querySelectorAll('[data-ctp-variant-link]'));
    this.variantInput = this.querySelector('input[name="id"]');
    this.addButton = this.querySelector('.ctp-card__add');

    this.swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => this.select(swatch));
    });
  }

  select(swatch) {
    const { variantId, title, url, image, srcset, available } = swatch.dataset;
    const isAvailable = available === 'true';

    if (this.image && image) {
      this.image.src = image;
      this.image.srcset = srcset || '';
    }

    if (this.titleLink) this.titleLink.textContent = title;

    this.links.forEach((link) => {
      link.href = url;
      if (link.hasAttribute('aria-label')) link.setAttribute('aria-label', title);
    });

    if (this.variantInput) {
      this.variantInput.value = variantId;
      this.variantInput.disabled = !isAvailable;
    }

    if (this.addButton) {
      this.addButton.disabled = !isAvailable;
      this.addButton.textContent = isAvailable ? 'Add to cart' : 'Sold out';
    }

    this.swatches.forEach((item) => {
      const active = item === swatch;
      item.classList.toggle('is-selected', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }
}

customElements.define('ctp-swatch-card', CtpSwatchCard);
